import React, { useEffect, useState } from "react";
import BranchInputs from "../../Inputs/BranchInputs/BranchInputs";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { createBranch } from "../../../redux/branchSlice/branchSlice";
import notify from "../../../hooks/useNotifaction";

export default function AddBranch({ setBranchData: externalSetBranchData, branchData: externalBranchData, handleForm: externalHandleForm, selectedCompany, handleNewBranch }) {
  const location = useLocation();
  const isAddBranchPage = location.pathname.endsWith("/AddBranch");
  const passedCompanyId = location.state?.company_id || "";
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, error } = useSelector((state) => state.branch);
  const [branchData, setBranchData] = useState({
    company_id: selectedCompany?.value || passedCompanyId,
    name: "",
    email: "",
    address: "",
    city: "",
    location: "",
    manager_name: "",
    phone: "",
    state: "",
  });

  async function handleForm(e) {
    e.preventDefault();
    const { name, email, address, city, location, manager_name, phone, state, company_id } = branchData;

    if (!company_id) return notify("يرجى اختيار الشركة أولًا", "error");
    if (!name) return notify("يرجى إدخال اسم الفرع", "error");
    if (!address) return notify("يرجى إدخال العنوان", "error");
    if (!city) return notify("يرجى إدخال المدينة", "error");
    if (!state) return notify("يرجى إدخال المحافظة", "error");
    if (!location) return notify("يرجى إدخال الموقع", "error");
    if (!manager_name) return notify("يرجى إدخال اسم المدير", "error");

    try {
      const filteredData = Object.fromEntries(Object.entries(branchData).filter(([_, value]) => value !== "" && value !== null && value !== undefined));

      let res = await dispatch(createBranch(filteredData)).unwrap();
      notify(res?.message || "تمت إضافة الفرع بنجاح", "success");

      if (!isAddBranchPage) {
        handleNewBranch();
      } else {
        navigate(-1);
      }

      setBranchData({
        company_id: "",
        name: "",
        email: "",
        address: "",
        city: "",
        location: "",
        manager_name: "",
        phone: "",
        state: "",
      });
      console.log(res);
    } catch (error) {
      console.error("Error adding branch:", error);
      notify(error?.message || "حدث خطأ أثناء إضافة الفرع", "error");
    }

    setLoading(false);
  }

  const handleInputChange = (name, value) => {
    setBranchData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <div className={isAddBranchPage ? "main" : ""}>
        <h2 className="text-white mb-4">اضافة فرع</h2>
        <form onSubmit={handleForm}>
          <div className={isAddBranchPage ? "card pt-5 pb-2 px-3 companyProfile" : "pt-5 pb-2 px-3 companyProfile"}>
            <BranchInputs branchData={branchData} onInputChange={handleInputChange} />
            <div>
              <button type="submit" className="btn btn-primary">
                <i className="fas fa-plus me-1"></i>
                اضافة
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
